import { t } from 'i18next';
import moment from 'moment';
import * as Yup from 'yup';
import { Day, DefaultDateType } from '../types';

const stringValidation = Yup.string().nullable();
const numberValidation = Yup.number()
  .required(`${t('required-field')}`)
  .typeError(`${t('required-field')}`);

type ValidationDate = DefaultDateType | any;

interface MyObject {
  [key: string | symbol]: any;
}

export const swapShiftValidations = Yup.object({
  secondEmployeeId: numberValidation,
  firstEmployeeShiftDates: Yup.array()
    .of(stringValidation)
    .required()
    .test('required', `${t('required-field')}`, function (value) {
      const { secondEmployeeShiftDates } = this.parent;

      if (
        !Array.isArray(secondEmployeeShiftDates) ||
        !Array.isArray(value) ||
        value.length === 0 ||
        secondEmployeeShiftDates.length === 0
      )
        return false;

      return true;
    })
    .test(
      'same-length',
      `${t(
        'Count of selected dates for first employee should be same for the second employee',
      )}`,
      function (value) {
        const { secondEmployeeShiftDates } = this.parent;
        if (value?.length !== secondEmployeeShiftDates?.length) return false;

        return true;
      },
    )
    .test(
      'same-dates',
      `${t(
        'Selected dates for the first employee should be same for the second employee',
      )}`,
      function (value) {
        const { secondEmployeeShiftDates } = this.parent;

        let selectedDates = {};

        value?.forEach((date: ValidationDate) => {
          selectedDates = {
            ...selectedDates,
            [date]: false,
          };
        });

        secondEmployeeShiftDates?.forEach((date: ValidationDate) => {
          selectedDates = {
            ...selectedDates,
            [date]: true,
          };
        });

        const invalidDate = Object.values(selectedDates).some(
          (value) => value === false,
        );

        if (!invalidDate) return true;

        return false;
      },
    )
    .test('prev-dates', `${t('Cannot swap previous dates')}`, function (value) {
      const currentDate = moment();

      const hasPrevDate = value?.some((date) =>
        moment(date).isSameOrBefore(currentDate),
      );

      return !hasPrevDate;
    })
    .test(
      'same-code',
      `${t(
        'Swap between shifts should be in same dates with different time shifts',
      )}`,
      function (value) {
        const {
          firstEmployeeShiftCodes,
          secondEmployeeShiftCodes,
          secondEmployeeShiftDates,
        } = this.parent;

        let selectedFirstEmployeeDates: MyObject = {};
        let selectedSecondEmployeeDates: MyObject = {};

        value?.forEach((date: ValidationDate, i) => {
          selectedFirstEmployeeDates = {
            ...selectedFirstEmployeeDates,
            [date]: firstEmployeeShiftCodes[i],
          };
        });

        secondEmployeeShiftDates?.forEach((date: ValidationDate, i: symbol) => {
          selectedSecondEmployeeDates = {
            ...selectedSecondEmployeeDates,
            [date]: secondEmployeeShiftCodes[i],
          };
        });

        const isSameCode = secondEmployeeShiftDates?.some(
          (date: ValidationDate) =>
            selectedFirstEmployeeDates[date] ===
            selectedSecondEmployeeDates[date],
        );

        return !isSameCode;
      },
    )
    .test(
      'check-isHoliday-isLeave',
      `${t('Cannot swap on holiday or leave days')}`,
      function () {
        const { firstEmployeeShiftsDetails } = this.parent;

        const isHolidayOrLeave = firstEmployeeShiftsDetails?.some(
          (shiftTime: Day) => shiftTime?.onLeave || shiftTime?.isHoliday,
        );

        return !isHolidayOrLeave;
      },
    ),
  secondEmployeeShiftDates: Yup.array()
    .of(stringValidation)
    .required()
    .test('required', `${t('required-field')}`, function (value) {
      const { firstEmployeeShiftDates } = this.parent;

      if (
        !Array.isArray(firstEmployeeShiftDates) ||
        !Array.isArray(value) ||
        value.length === 0 ||
        firstEmployeeShiftDates.length === 0
      )
        return false;

      return true;
    })
    .test(
      'same-length',
      `${t(
        'Count of selected dates for first employee should be same for the second employee',
      )}`,
      function (value) {
        const { firstEmployeeShiftDates } = this.parent;
        if (value?.length !== firstEmployeeShiftDates?.length) return false;

        return true;
      },
    )
    .test(
      'same-dates',
      `${t(
        'Selected dates for the second employee should be same for the first employee',
      )}`,
      function (value) {
        const { firstEmployeeShiftDates } = this.parent;

        let selectedDates = {};

        value?.forEach((date: ValidationDate) => {
          selectedDates = {
            ...selectedDates,
            [date]: false,
          };
        });

        firstEmployeeShiftDates?.forEach((date: ValidationDate) => {
          selectedDates = {
            ...selectedDates,
            [date]: true,
          };
        });

        const invalidDate = Object.values(selectedDates).some(
          (value) => value === false,
        );

        if (!invalidDate) return true;

        return false;
      },
    )
    .test('prev-dates', `${t('Cannot swap previous dates')}`, function (value) {
      const currentDate = moment();

      const hasPrevDate = value?.some((date) =>
        moment(date).isSameOrBefore(currentDate),
      );

      return !hasPrevDate;
    })
    .test(
      'same-code',
      `${t(
        'Swap between shifts should be in same dates with different time shifts',
      )}`,
      function (value) {
        const {
          firstEmployeeShiftCodes,
          secondEmployeeShiftCodes,
          firstEmployeeShiftDates,
        } = this.parent;

        let selectedFirstEmployeeDates: MyObject = {};
        let selectedSecondEmployeeDates: MyObject = {};

        value?.forEach((date: ValidationDate, i) => {
          selectedSecondEmployeeDates = {
            ...selectedSecondEmployeeDates,
            [date]: secondEmployeeShiftCodes[i],
          };
        });

        firstEmployeeShiftDates?.forEach((date: ValidationDate, i: symbol) => {
          selectedFirstEmployeeDates = {
            ...selectedFirstEmployeeDates,
            [date]: firstEmployeeShiftCodes[i],
          };
        });

        const isSameCode = firstEmployeeShiftDates?.some(
          (date: ValidationDate) =>
            selectedFirstEmployeeDates[date] ===
            selectedSecondEmployeeDates[date],
        );

        return !isSameCode;
      },
    )
    .test(
      'check-isHoliday-isLeave',
      `${t('Cannot swap on holiday or leave days')}`,
      function () {
        const { secondEmployeeShiftsDetails } = this.parent;

        const isHolidayOrLeave = secondEmployeeShiftsDetails?.some(
          (shiftTime: Day) => shiftTime?.onLeave || shiftTime?.isHoliday,
        );

        return !isHolidayOrLeave;
      },
    ),
});
